export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  OTP_VERIFICATION: '/otp-verification',

  // Protected routes
  DASHBOARD: '/dashboard',
  MARKETERS: '/marketers',
  MARKETERS_DETAIL_LIST: '/marketers/:id',
  MERCHANTS: '/merchants',
  MERCHANTS_DETAIL: '/merchants/:id',
  TOPUP_CASHBACK: '/topup-cashback',
  ONE_SNAP: '/transactions/1-snap',
  ONE_SNAP_DETAIL: '/transactions/1-snap/:id',
  REVERSAL: '/transactions/reversal',
  REVERSAL_DETAIL: '/transactions/reversal/:id',
  ROLES: '/roles',

  // User Management
  USERS: '/users',
  USER_CREATE: '/users/create',
  USER_EDIT: '/users/:id/edit',
  USER_PROFILE: '/users/:id',

  // Content Management
  CONTENT: '/content',
  POSTS: '/content/posts',
  POST_CREATE: '/content/posts/create',
  POST_EDIT: '/content/posts/:id/edit',
  CATEGORIES: '/content/categories',
  MEDIA: '/content/media',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_GENERAL: '/settings/general',
  SETTINGS_SECURITY: '/settings/security',
  SETTINGS_NOTIFICATIONS: '/settings/notifications',
  SETTINGS_INTEGRATIONS: '/settings/integrations',

  // Profile
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',

  // Analytics
  ANALYTICS: '/analytics',
  REPORTS: '/reports',

  // Audit
  AUDIT_LOGS: '/audit/logs',

  // Error pages
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/401',
  SERVER_ERROR: '/500',

  // Helper function to generate dynamic routes
  generatePath: (route, params = {}) => {
    let path = route;
    Object.keys(params).forEach(key => {
      path = path.replace(`:${key}`, params[key]);
    });
    return path;
  },
};
